import React from 'react';

import { useAppDispatch, useAppSelector } from 'store';
import { SampleList } from 'components/Sample/SampleList';
import { PageTitles } from 'constants/pageTitles';
import {
  loadTouristRoutesList,
  saveTouristRoutesItem,
} from 'store/slices/touristRoutes/actions';
import { ITouristRoutesItem } from 'store/slices/touristRoutes/interfaces';

interface IProps {
  sortFieldName?: keyof Pick<
    ITouristRoutesItem,
    'sortPriority' | 'sortPriorityMainPage'
  >;
  limit?: number;
  addON?: boolean;
  deleteON?: boolean;
  isSortPriority?: boolean | null;
}

export const List: React.FC<IProps> = ({
  sortFieldName = 'sortPriority',
  limit,
  addON,
  deleteON,
  isSortPriority = true,
}) => {
  const dispatch = useAppDispatch();
  const data = useAppSelector(state => state.touristRoutes);

  const tableData = data.list.map(item => ({
    title: item.name,
    id: item.id,
    sortPriority: item[sortFieldName],
    image: item.image,
  }));

  const handleRemove = async (id: number): Promise<any> => {
    return dispatch(
      saveTouristRoutesItem({
        id,
        [sortFieldName]: null,
      })
    ).unwrap();
  };

  const handleLoadData = (lang: string) => {
    dispatch(
      loadTouristRoutesList({
        lang: lang,
        limit,
        sort: sortFieldName,
        isSortPriority,
      })
    );
  };

  return (
    <SampleList
      data={tableData}
      handleLoadData={handleLoadData}
      handleDelete={handleRemove}
      isLoading={data.isLoading}
      title={PageTitles.touristRoutes}
      limit={limit}
      addON={addON}
      deleteON={deleteON}
    />
  );
};
